export const purchaseFormRoutes: Record<string, any> = {
  purchase_detail: '/mortgage/purchase/step/purchase-detail',
  personal_detail: '/mortgage/purchase/step/personal-detail',
  property_detail: '/mortgage/purchase/step/property-detail',
  income_detail: '/mortgage/purchase/step/income-detail',
  primary_detail: '/mortgage/purchase/step/primary-detail',
};
